<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Reward Category</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <label for="nameTh">Name (TH)<span class="required">*</span></label>
          <input
            id="nameTh"
            v-model="form.nameTh"
            type="text"
            class="form-control"
          />
          <div v-if="isSubmit && error.errorNameTh" class="text-error">
            {{ error.errorNameTh.message }}
          </div>
        </div>
        <div class="col">
          <label for="nameEn">Name (EN)<span class="required">*</span></label>
          <input
            id="nameEn"
            v-model="form.nameEn"
            type="text"
            class="form-control"
          />
          <div v-if="isSubmit && error.errorNameEn" class="text-error">
            {{ error.errorNameEn.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BrandDropdown
            v-model="form.brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
            required="true"
          ></BrandDropdown>
          <div v-if="isSubmit && error.errorBrandCode" class="text-error">
            {{ error.errorBrandCode.message }}
          </div>
        </div>
        <div class="col">
          <label for="selectedRewardType">
            Reward type<span class="required">*</span></label
          >
          <multiselect
            id="selectedRewardType"
            v-model="form.rewardType"
            :options="rewardTypeOptions"
            label="text"
            track-by="code"
          >
          </multiselect>
          <div v-if="isSubmit && error.errorRewardType" class="text-error">
            {{ error.errorRewardType.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex flex-row">
            <input
              class="form-check-input mr-2"
              id="isActive"
              type="checkbox"
              v-model="form.status"
              :class="{
                'input--error': isSubmit && error.errorStatus,
              }"
            />
            <label class="form-check-label" for="isActive"> Active </label>
          </div>
          <div v-if="isSubmit && error.errorStatus" class="text-error">
            {{ error.errorStatus.message }}
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <router-link
          :to="{ name: 'RewardCategory' }"
          class="btn btn-outline-danger btn-cancel"
          >Cancel</router-link
        >
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
    </div>

    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="row text-center">
          <div v-if="showSuccess && id" class="col-12">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="col-12">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'RewardCategory' })"
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
        </div>
        <div v-if="!showSuccess" class="row text-center">
          <div class="col">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import RewardCategoryService from "services/api/rewardCategory.service";

export default {
  components: {
    BrandDropdown,
  },

  data() {
    return {
      id: this.$route.query.id,
      message: null,
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      isSubmit: false,
      rewardTypeOptions: [
        { text: "Rewards", code: "REWARDS" },
        { text: "Packages", code: "PACKAGES" },
      ],
      form: {
        nameTh: null,
        nameEn: null,
        brandSelected: null,
        rewardType: null,
        status: false,
      },
      error: {
        errorNameTh: "",
        errorNameEn: "",
        errorBrandCode: "",
        errorRewardType: "",
        errorStatus: "",
      },
    };
  },
  async mounted() {
    if (this.id) {
      this.isLoading = true;
      await this.getRewardCategoryDetail(this.id);
    }
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.resetErrorText();
      const form = this.form;
      const body = {
        nameTh: form.nameTh,
        nameEn: form.nameEn,
        brandCode: form.brandSelected?.id,
        rewardType: form.rewardType?.code,
        status: form.status ? "ACTIVE" : "INACTIVE",
      };
      if (this.id) {
        this.updateExistingRewardCategory(body);
      } else {
        this.createNewRewardCategory(body);
      }
    },
    createNewRewardCategory(body) {
      RewardCategoryService.createRewardCategory(body)
        .then((res) => {
          this.createOrUpdateSuccess(res);
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    updateExistingRewardCategory(body) {
      RewardCategoryService.updateRewardCategory(body, this.id)
        .then((res) => {
          this.createOrUpdateSuccess(res);
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    createOrUpdateSuccess(res) {
      this.isLoading = false;
      const data = res.data;
      this.showDialog = true;
      this.showSuccess = true;
      this.message = data.message
        ? data.message
        : "Save reward category success";
    },
    createOrUpdateFailure(err) {
      this.isLoading = false;
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        this.setErrorText(errorData.errors);
        return;
      }
      if (errorData.message) {
        this.showDialog = true;
        this.message = errorData.message;
      }
    },
    async getRewardCategoryDetail() {
      await RewardCategoryService.getDetailRewardCategory(this.id)
        .then((res) => {
          this.isLoading = false;
          this.isUploading = false;
          const data = res.data.rewardCategory;
          const form = this.form;
          form.nameTh = data.nameTh;
          form.nameEn = data.nameEn;
          form.brandSelected = data.brandCode;
          form.rewardType = this.rewardTypeOptions.find(
            (r) => r.code === data.rewardType
          );
          form.status = data.status === "ACTIVE";
        })
        .catch((err) => {
          this.createOrUpdateFailure(err);
        });
    },
    async setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    setBrand(brand) {
      this.form.brandSelected = brand || "";
    },
    setBrands(brands) {
      brands.forEach((brand) => {
        if (brand.id === this.form.brandSelected) {
          this.form.brandSelected = brand;
        }
      });
    },
    setErrorText(errors) {
      this.error.errorNameTh = errors.find((e) => e.fieldName === "nameTh");
      this.error.errorNameEn = errors.find((e) => e.fieldName === "nameEn");
      this.error.errorBrandCode = errors.find(
        (e) => e.fieldName === "brandCode"
      );
      this.error.errorRewardType = errors.find(
        (e) => e.fieldName === "rewardType"
      );
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
    },
    resetErrorText() {
      this.error = {
        errorNameTh: "",
        errorNameEn: "",
        errorBrandCode: "",
        errorRewardType: "",
        errorStatus: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}
</style>
